'use client';

import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { usePageView } from '@jouzen/web-analytics-store/client';

import { usePathname } from '@/config';

/** Matches bulk order ids (e.g. BO-1, BO-12345678910) */
const BULK_ORDER_ID_REGEX = /BO-\d+/;

const PageLoadEventProvider = ({ children }: PropsWithChildren) => {
  const pathname = usePathname() as null | string | undefined;
  const normalizedPathname = pathname ?? '';
  const bulkOrderId = normalizedPathname.match(BULK_ORDER_ID_REGEX)?.[0];
  const enrichProperties = useMemo(
    () => () => ({
      pathname: normalizedPathname,
      ...(bulkOrderId && { bulkOrderId }),
    }),
    [normalizedPathname, bulkOrderId],
  );

  usePageView(normalizedPathname, { enrichProperties });

  return <>{children}</>;
};

export default PageLoadEventProvider;
